export const loadVenue        = (venueId) => ({type : 'LOAD_VENUE_REQUEST', payload : {venueId}});
export const toggleVenueState = (state) => ({type : 'TOGGLE_VENUE_STATE_REQUEST', payload : {state}});
